import ActionRunEffect from "@/assets/video-motion-effects/ACTION_RUN.mp4";
import AgentRevealEffect from "@/assets/video-motion-effects/AGENT_REVEAL.mp4";
import ArcLeftEffect from "@/assets/video-motion-effects/ARC_LEFT.mp4";
import ArcRightEffect from "@/assets/video-motion-effects/ARC_RIGHT.mp4";
import BasketballDunksEffect from "@/assets/video-motion-effects/BASKETBALL_DUNKS.mp4";
import BuildingExplosionEffect from "@/assets/video-motion-effects/BUILDING_EXPLOSION.mp4";
import BulletTimeEffect from "@/assets/video-motion-effects/BULLET_TIME.mp4";
import CarChasingEffect from "@/assets/video-motion-effects/CAR_CHASING.mp4";
import CarExplosionEffect from "@/assets/video-motion-effects/CAR_EXPLOSION.mp4";
import CarGripEffect from "@/assets/video-motion-effects/CAR_GRIP.mp4";
import CraneDownEffect from "@/assets/video-motion-effects/CRANE_DOWN.mp4";
import CraneOverTheHeadEffect from "@/assets/video-motion-effects/CRANE_OVER_THE_HEAD.mp4";
import CraneUpEffect from "@/assets/video-motion-effects/CRANE_UP.mp4";
import CrashZoomInEffect from "@/assets/video-motion-effects/CRASH_ZOOM_IN.mp4";
import CrashZoomOutEffect from "@/assets/video-motion-effects/CRASH_ZOOM_OUT.mp4";
import DirtyLensEffect from "@/assets/video-motion-effects/DIRTY_LENS.mp4";
import DisintegrationEffect from "@/assets/video-motion-effects/DISINTEGRATION.mp4";
import DollyInEffect from "@/assets/video-motion-effects/DOLLY_IN.mp4";
import DollyLeftEffect from "@/assets/video-motion-effects/DOLLY_LEFT.mp4";
import DollyOutEffect from "@/assets/video-motion-effects/DOLLY_OUT.mp4";
import DollyRightEffect from "@/assets/video-motion-effects/DOLLY_RIGHT.mp4";
import DollyZoomInEffect from "@/assets/video-motion-effects/DOLLY_ZOOM_IN.mp4";
import DollyZoomOutEffect from "@/assets/video-motion-effects/DOLLY_ZOOM_OUT.mp4";
import DoubleDollyEffect from "@/assets/video-motion-effects/DOUBLE_DOLLY.mp4";
import DutchAngleEffect from "@/assets/video-motion-effects/DUTCH_ANGLE.mp4";
import EyesInEffect from "@/assets/video-motion-effects/EYES_IN.mp4";
import FacePunchEffect from "@/assets/video-motion-effects/FACE_PUNCH.mp4";
import FisheyeEffect from "@/assets/video-motion-effects/FISHEYE.mp4";
import FlyingEffect from "@/assets/video-motion-effects/FLYING.mp4";
import FocusChangeEffect from "@/assets/video-motion-effects/FOCUS_CHANGE.mp4";
import FpvDroneEffect from "@/assets/video-motion-effects/FPV_DRONE.mp4";
import GeneralEffect from "@/assets/video-motion-effects/GENERAL.mp4";
import GlamEffect from "@/assets/video-motion-effects/GLAM.mp4";
import HandheldEffect from "@/assets/video-motion-effects/HANDHELD.mp4";
import HeadTrackingEffect from "@/assets/video-motion-effects/HEAD_TRACKING.mp4";
import HyperlapseEffect from "@/assets/video-motion-effects/HYPERLAPSE.mp4";
import InvisibleEffect from "@/assets/video-motion-effects/INVISIBLE.mp4";
import JibDownEffect from "@/assets/video-motion-effects/JIB_DOWN.mp4";
import JibUpEffect from "@/assets/video-motion-effects/JIB_UP.mp4";
import KissEffect from "@/assets/video-motion-effects/KISS.mp4";
import LazySusanEffect from "@/assets/video-motion-effects/LAZY_SUSAN.mp4";
import LensCrackEffect from "@/assets/video-motion-effects/LENS_CRACK.mp4";
import LensFlareEffect from "@/assets/video-motion-effects/LENS_FLARE.mp4";
import LevitationEffect from "@/assets/video-motion-effects/LEVITATION.mp4";
import LowShutterEffect from "@/assets/video-motion-effects/LOW_SHUTTER.mp4";
import MeltingEffect from "@/assets/video-motion-effects/MELTING.mp4";
import MouthInEffect from "@/assets/video-motion-effects/MOUTH_IN.mp4";
import ObjectPovEffect from "@/assets/video-motion-effects/OBJECT_POV.mp4";
import Orbit360Effect from "@/assets/video-motion-effects/ORBIT_360.mp4";
import OverheadEffect from "@/assets/video-motion-effects/OVERHEAD.mp4";
import PushToGlassEffect from "@/assets/video-motion-effects/PUSH_TO_GLASS.mp4";
import RapFlexEffect from "@/assets/video-motion-effects/RAP_FLEX.mp4";
import RoboArmEffect from "@/assets/video-motion-effects/ROBO_ARM.mp4";
import SetOnFireEffect from "@/assets/video-motion-effects/SET_ON_FIRE.mp4";
import SnorricamEffect from "@/assets/video-motion-effects/SNORRICAM.mp4";
import SoulJumpEffect from "@/assets/video-motion-effects/SOUL_JUMP.mp4";
import StaticEffect from "@/assets/video-motion-effects/STATIC.mp4";
import SuperDollyInEffect from "@/assets/video-motion-effects/SUPER_DOLLY_IN.mp4";
import SuperDollyOutEffect from "@/assets/video-motion-effects/SUPER_DOLLY_OUT.mp4";
import TentaclesEffect from "@/assets/video-motion-effects/TENTACLES.mp4";
import ThroughObjectInEffect from "@/assets/video-motion-effects/THROUGH_OBJECT_IN.mp4";
import ThroughObjectOutEffect from "@/assets/video-motion-effects/THROUGH_OBJECT_OUT.mp4";
import ThunderGodEffect from "@/assets/video-motion-effects/THUNDER_GOD.mp4";
import TiltDownEffect from "@/assets/video-motion-effects/TILT_DOWN.mp4";
import TiltUpEffect from "@/assets/video-motion-effects/TILT_UP.mp4";
import TimelapseHumanEffect from "@/assets/video-motion-effects/TIMELAPSE_HUMAN.mp4";
import TimelapseLandscapeEffect from "@/assets/video-motion-effects/TIMELAPSE_LANDSCAPE.mp4";
import TurningMetalEffect from "@/assets/video-motion-effects/TURNING_METAL.mp4";
import WhipPanEffect from "@/assets/video-motion-effects/WHIP_PAN.mp4";
import WiggleEffect from "@/assets/video-motion-effects/WIGGLE.mp4";
import WindToFaceEffect from "@/assets/video-motion-effects/WIND_TO_FACE.mp4";
import YoyoZoomEffect from "@/assets/video-motion-effects/YOYO_ZOOM.mp4";
import ZoomInEffect from "@/assets/video-motion-effects/ZOOM_IN.mp4";
import ZoomOutEffect from "@/assets/video-motion-effects/ZOOM_OUT.mp4";
import { VideoEffectType } from "@/components/graphql/schema.graphql";
import type { VideoEffectData } from "@/types";

export const VIDEO_EFFECT_TYPE_METADATA: Record<
  VideoEffectType,
  VideoEffectData
> = {
  GENERAL: {
    title: "General",
    thumbnail: GeneralEffect,
  },

  ACTION_RUN: {
    title: "Action Run",
    thumbnail: ActionRunEffect,
  },
  AGENT_REVEAL: {
    title: "Agent Reveal",
    thumbnail: AgentRevealEffect,
  },
  ARC: {
    title: "Arc",
    thumbnail: ArcRightEffect,
  },
  ARC_LEFT: {
    title: "Arc Left",
    thumbnail: ArcLeftEffect,
  },
  BASEBALL_KICK: {
    title: "Baseball Kick",
    thumbnail: GeneralEffect, // TODO: Add Baseball Kick Effect
  },
  BASKETBALL_DUNKS: {
    title: "Basketball Dunks",
    thumbnail: BasketballDunksEffect,
  },
  BOXING: {
    title: "Boxing",
    thumbnail: GeneralEffect, // TODO: Add Boxing Effect
  },
  BUCKLE_UP: {
    title: "Buckle Up",
    thumbnail: GeneralEffect, // TODO: Add Buckle Up Effect
  },
  BUILDING_EXPLOSION: {
    title: "Building Explosion",
    thumbnail: BuildingExplosionEffect,
  },
  BULLET_TIME: {
    title: "Bullet Time",
    thumbnail: BulletTimeEffect,
  },
  CAR_CHASING: {
    title: "Car Chasing",
    thumbnail: CarChasingEffect,
  },
  CAR_EXPLOSION: {
    title: "Car Explosion",
    thumbnail: CarExplosionEffect,
  },
  CAR_GRIP: {
    title: "Car Grip",
    thumbnail: CarGripEffect,
  },
  CATCH: {
    title: "Catch",
    thumbnail: FlyingEffect, // TODO: Add Catch Effect
  },
  CATWALK: {
    title: "Catwalk",
    thumbnail: FlyingEffect, // TODO: Add Catwalk Effect
  },
  CRANE_DOWN: {
    title: "Crane Down",
    thumbnail: CraneDownEffect,
  },
  CRANE_OVER_THE_HEAD: {
    title: "Crane Over The Head",
    thumbnail: CraneOverTheHeadEffect,
  },
  CRANE_UP: {
    title: "Crane Up",
    thumbnail: CraneUpEffect,
  },
  CRASH_ZOOM_IN: {
    title: "Crash Zoom In",
    thumbnail: CrashZoomInEffect,
  },
  CRASH_ZOOM_OUT: {
    title: "Crash Zoom Out",
    thumbnail: CrashZoomOutEffect,
  },
  DIRTY_LENS: {
    title: "Dirty Lens",
    thumbnail: DirtyLensEffect,
  },
  DISINTEGRATION: {
    title: "Disintegration",
    thumbnail: DisintegrationEffect,
  },
  DOLLY_IN: {
    title: "Dolly In",
    thumbnail: DollyInEffect,
  },
  DOLLY_LEFT: {
    title: "Dolly Left",
    thumbnail: DollyLeftEffect,
  },
  DOLLY_OUT: {
    title: "Dolly Out",
    thumbnail: DollyOutEffect,
  },
  DOLLY_RIGHT: {
    title: "Dolly Right",
    thumbnail: DollyRightEffect,
  },
  DOLLY_ZOOM_IN: {
    title: "Dolly Zoom In",
    thumbnail: DollyZoomInEffect,
  },
  DOLLY_ZOOM_OUT: {
    title: "Dolly Zoom Out",
    thumbnail: DollyZoomOutEffect,
  },
  DOUBLE_DOLLY: {
    title: "Double Dolly",
    thumbnail: DoubleDollyEffect,
  },
  DOWNHILL_POV: {
    title: "Downhill POV",
    thumbnail: FlyingEffect, // TODO: Add Downhill POV Effect
  },
  DUTCH_ANGLE: {
    title: "Dutch Angle",
    thumbnail: DutchAngleEffect,
  },
  EYES_IN: {
    title: "Eyes In",
    thumbnail: EyesInEffect,
  },
  FACE_PUNCH: {
    title: "Face Punch",
    thumbnail: FacePunchEffect,
  },
  FISHEYE: {
    title: "Fisheye",
    thumbnail: FisheyeEffect,
  },
  FLYING: {
    title: "Flying",
    thumbnail: FlyingEffect,
  },
  FOCUS_CHANGE: {
    title: "Focus Change",
    thumbnail: FocusChangeEffect,
  },
  FPV_DRONE: {
    title: "FPV Drone",
    thumbnail: FpvDroneEffect,
  },
  GLAM: {
    title: "Glam",
    thumbnail: GlamEffect,
  },
  HANDHELD: {
    title: "Handheld",
    thumbnail: HandheldEffect,
  },
  HEAD_TRACKING: {
    title: "Head Tracking",
    thumbnail: HeadTrackingEffect,
  },
  HYPERLAPSE: {
    title: "Hyperlapse",
    thumbnail: HyperlapseEffect,
  },
  INVISIBLE: {
    title: "Invisible",
    thumbnail: InvisibleEffect,
  },
  JIB_DOWN: {
    title: "Jib Down",
    thumbnail: JibDownEffect,
  },
  JIB_UP: {
    title: "Jib Up",
    thumbnail: JibUpEffect,
  },
  KISS: {
    title: "Kiss",
    thumbnail: KissEffect,
  },
  LAZY_SUSAN: {
    title: "Lazy Susan",
    thumbnail: LazySusanEffect,
  },
  LENS_CRACK: {
    title: "Lens Crack",
    thumbnail: LensCrackEffect,
  },
  LENS_FLARE: {
    title: "Lens Flare",
    thumbnail: LensFlareEffect,
  },
  LEVITATION: {
    title: "Levitation",
    thumbnail: LevitationEffect,
  },
  LOW_SHUTTER: {
    title: "Low Shutter",
    thumbnail: LowShutterEffect,
  },
  MELTING: {
    title: "Melting",
    thumbnail: MeltingEffect,
  },
  MOONWALK_LEFT: {
    title: "Moonwalk Left",
    thumbnail: FlyingEffect, // TODO: Add Moonwalk Left Effect
  },
  MOONWALK_RIGHT: {
    title: "Moonwalk Right",
    thumbnail: FlyingEffect, // TODO: Add Moonwalk Right Effect
  },
  MOUTH_IN: {
    title: "Mouth In",
    thumbnail: MouthInEffect,
  },
  OBJECT_POV: {
    title: "Object POV",
    thumbnail: ObjectPovEffect,
  },
  ORBIT_360: {
    title: "Orbit 360",
    thumbnail: Orbit360Effect,
  },
  OVERHEAD: {
    title: "Overhead",
    thumbnail: OverheadEffect,
  },
  PUSH_TO_GLASS: {
    title: "Push To Glass",
    thumbnail: PushToGlassEffect,
  },
  RAP_FLEX: {
    title: "Rap Flex",
    thumbnail: RapFlexEffect,
  },
  ROBO_ARM: {
    title: "Robo Arm",
    thumbnail: RoboArmEffect,
  },
  SET_ON_FIRE: {
    title: "Set on Fire",
    thumbnail: SetOnFireEffect,
  },
  SKATEBOARDING: {
    title: "Skateboarding",
    thumbnail: FlyingEffect, // TODO: Add Skateboarding Effect
  },
  SKATEBOARD_GLIDE: {
    title: "Skateboard Glide",
    thumbnail: FlyingEffect, // TODO: Add Skateboard Glide Effect
  },
  SKATEBOARD_KICKFLIP: {
    title: "Skateboard Kickflip",
    thumbnail: FlyingEffect, // TODO: Add Skateboard Kickflip Effect
  },
  SKATEBOARD_OLLIE: {
    title: "Skateboard Ollie",
    thumbnail: FlyingEffect, // TODO: Add Skateboard Ollie Effect
  },
  SKATE_CRUISE: {
    title: "Skate Cruise",
    thumbnail: FlyingEffect, // TODO: Add Skate Cruise Effect
  },
  SKI_CARVING: {
    title: "Ski Carving",
    thumbnail: FlyingEffect, // TODO: Add Ski Carving Effect
  },
  SKI_POWDER: {
    title: "Ski Powder",
    thumbnail: FlyingEffect, // TODO: Add Ski Powder Effect
  },
  SNORRICAM: {
    title: "Snorricam",
    thumbnail: SnorricamEffect,
  },
  SNOWBOARD_CARVING: {
    title: "Snowboard Carving",
    thumbnail: FlyingEffect, // TODO: Add Snowboard Carving Effect
  },
  SNOWBOARD_POWDER: {
    title: "Snowboard Powder",
    thumbnail: FlyingEffect, // TODO: Add Snowboard Powder Effect
  },
  SOUL_JUMP: {
    title: "Soul Jump",
    thumbnail: SoulJumpEffect,
  },
  STATIC: {
    title: "Static",
    thumbnail: StaticEffect,
  },
  SUPER_DOLLY_IN: {
    title: "Super Dolly In",
    thumbnail: SuperDollyInEffect,
  },
  SUPER_DOLLY_OUT: {
    title: "Super Dolly Out",
    thumbnail: SuperDollyOutEffect,
  },
  TENTACLES: {
    title: "Tentacles",
    thumbnail: TentaclesEffect,
  },
  THROUGH_OBJECT_IN: {
    title: "Through Object In",
    thumbnail: ThroughObjectInEffect,
  },
  THROUGH_OBJECT_OUT: {
    title: "Through Object Out",
    thumbnail: ThroughObjectOutEffect,
  },
  THUNDER_GOD: {
    title: "Thunder God",
    thumbnail: ThunderGodEffect,
  },
  TILT_DOWN: {
    title: "Tilt Down",
    thumbnail: TiltDownEffect,
  },
  TILT_UP: {
    title: "Tilt up",
    thumbnail: TiltUpEffect,
  },
  TIMELAPSE_HUMAN: {
    title: "Timelapse Human",
    thumbnail: TimelapseHumanEffect,
  },
  TIMELAPSE_LANDSCAPE: {
    title: "Timelapse Landscape",
    thumbnail: TimelapseLandscapeEffect,
  },
  TURNING_METAL: {
    title: "Turning Metal",
    thumbnail: TurningMetalEffect,
  },
  WHIP_PAN: {
    title: "Whip Pan",
    thumbnail: WhipPanEffect,
  },
  WIGGLE: {
    title: "Wiggle",
    thumbnail: WiggleEffect,
  },
  WIND_TO_FACE: {
    title: "Wind to Face",
    thumbnail: WindToFaceEffect,
  },
  YOYO_ZOOM: {
    title: "YoYo Zoom",
    thumbnail: YoyoZoomEffect,
  },
  ZOOM_IN: {
    title: "Zoom In",
    thumbnail: ZoomInEffect,
  },
  ZOOM_OUT: {
    title: "Zoom Out",
    thumbnail: ZoomOutEffect,
  },
};
